import tags, { en as tagsEN, ca as tagsCA } from './tags'

export default {
  whatsNew: '¿Qué hay de nuevo?',
  backToList: 'Volver a las notificaciones',
  loadMore: 'Mostrar más',
  tags
}

export const en = {
  whatsNew: 'What\'s new?',
  backToList: 'Back to notifications',
  loadMore: 'Show more',
  tags: tagsEN
}

export const ca = {
  whatsNew: 'Què hi ha de nou?',
  backToList: 'Tornar a les notificacions',
  loadMore: 'Mostrar més',
  tags: tagsCA
}
